///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { times } from "lodash";

import PendingBidsTableHeader from "../../components/pending-bids/PendingBidsTableHeader";

function PendingBidsLoading() {
  const BodyCell = ({ className }) => (
    <td
      className={
        "body-cell content-placeholder py-16 px-8 " + (className || "")
      }
    >
      <span></span>
    </td>
  );

  return (
    <table
      className="one-whole pending-bids-grid"
      data-testid="pending-bids-loading"
    >
      <PendingBidsTableHeader />
      <tbody>
        {times(18, index => (
          <tr className="row" key={index}>
            {times(9, columnIndex => (
              <BodyCell key={`loading-${index}-${columnIndex}`} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default PendingBidsLoading;
